import httpService from '@/core/http-service'

function tryLoginTestUser() {
  const username = process.env.VUE_APP_TEST_USER
  const password = process.env.VUE_APP_TEST_PASSWORD
  return new Promise(resolve => {
    if(username && password) {
      try {
        httpService.post('auth/signin', {
          username: username,
          password: password
          // rememberMe: false,
          // mergeCart: false,
          // url: window.location.search.replace(/\?returnurl=/ig, '')
        })
      } finally {
        resolve()
      }
    } else {
      resolve()
    }
  })
}

export default { tryLoginTestUser }
